<script>
import { api } from "@/state/services";
import ChartProProgress from "@/components/widgets/chart-pro-progress";

export default {
  locales: {
    pt: {
      'Become VIP!': 'Seja VIP!',
    },
    es: {
      'Become VIP!': '¡Sé VIP!',
    }
  },
  components: {
    ChartProProgress
  },
  data() {
    return {
      pro: {
        id: '',
        name: '',
        discount: '',
      },
    };
  },
  methods: {
    getPro() {
      api
        .get('reports/pro')
        .then(response => {
          if (response.data.status == 'success') {
            this.pro = response.data.pro
          }
        })
    },
  },
  mounted() {
    this.getPro()
  },
};
</script>

<template>
  <fieldset class="px-0">
    <legend>{{ t('Become VIP!') }}</legend>
    <ChartProProgress :current-level="pro.id" />
  </fieldset>
</template>
